export enum OrderDetailTypes {
  PENDING,
  PENDING_APPROVAL_OR_APPROVED,
  COMPLETED,
  CANCELED,
  UNKNOWN,
  RETURNED,
  THIRD_PARTY_HANDLED,
}
